import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { PoweredBy } from "@/components/PoweredBy";
import { toast } from "sonner";
import { ArrowLeft, UserPlus, CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cabin = (() => { try { return JSON.parse(localStorage.getItem("sf_cabin") || "null"); } catch { return null; } })();

export default function CabinVisitors() {
  const navigate = useNavigate();
  const token = localStorage.getItem("sf_cabin_token");
  const H = { headers: { Authorization: `Bearer ${token}` } };
  const [list, setList] = useState(null);
  const load = () => axios.get(`${API}/public/cabin/my/visitors`, H).then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { if (!token) { navigate("/login"); return; } load(); }, []);
  const act = async (v, a) => { try { await axios.post(`${API}/public/cabin/my/visitors/${v.id}/${a}`, {}, H); toast.success(a === "approve" ? "Approved" : "Rejected"); load(); } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); } };
  const pending = (list || []).filter((v) => ["PENDING_EMPLOYEE_APPROVAL", "HOLD"].includes(v.status));

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-navy-900 px-5 py-4"><button onClick={() => navigate("/cabin-portal")} className="text-blue-100/80 hover:text-white flex items-center gap-1.5 text-sm"><ArrowLeft size={16} /> Portal</button></header>
      <main className="max-w-lg mx-auto px-4 py-6">
        <h1 className="font-display text-xl font-bold text-navy-900 mb-4">Visitor Management</h1>
        <Button onClick={() => cabin?.branch_public_id ? navigate(`/visitor/${cabin.branch_public_id}`) : toast.error("Not configured")} data-testid="pre-request-btn" className="w-full h-12 bg-navy-900 hover:bg-navy-800 mb-6"><UserPlus size={16} className="mr-2" /> Pre-Request a Visitor</Button>
        <p className="text-sm font-semibold text-slate-500 mb-3">Approve Visitors ({pending.length})</p>
        {!list ? <div className="flex justify-center py-8"><Loader2 className="animate-spin text-navy-900" /></div> : pending.length === 0 ? (
          <div className="bg-white rounded-2xl border border-slate-200 p-6 text-center text-slate-500 text-sm">No visitors awaiting your approval.</div>
        ) : pending.map((v) => (
          <div key={v.id} className="bg-white rounded-2xl border border-slate-200 p-4 mb-3" data-testid={`approve-card-${v.id}`}>
            <p className="font-semibold text-navy-900">{v.visitor_name}</p>
            <p className="text-sm text-slate-500">{v.visitor_company} · {v.visitor_phone}</p>
            <p className="text-xs text-slate-400 mt-1">Purpose: {v.purpose}</p>
            <div className="flex gap-2 mt-3">
              <Button size="sm" onClick={() => act(v, "approve")} data-testid={`approve-btn-${v.id}`} className="bg-emerald-600 hover:bg-emerald-700 flex-1"><CheckCircle2 size={15} className="mr-1" /> Approve</Button>
              <Button size="sm" variant="outline" onClick={() => act(v, "reject")} data-testid={`reject-btn-${v.id}`} className="border-rose-200 text-rose-600 hover:bg-rose-50 flex-1"><XCircle size={15} className="mr-1" /> Reject</Button>
            </div>
          </div>
        ))}
        <div className="mt-8 flex justify-center"><PoweredBy /></div>
      </main>
    </div>
  );
}
